import { render, staticRenderFns } from "./ApplicantEmergencyContact.vue?vue&type=template&id=68890306&scoped=true&"
import script from "./ApplicantEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./ApplicantEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68890306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68890306')) {
      api.createRecord('68890306', component.options)
    } else {
      api.reload('68890306', component.options)
    }
    module.hot.accept("./ApplicantEmergencyContact.vue?vue&type=template&id=68890306&scoped=true&", function () {
      api.rerender('68890306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantEmergencyContact.vue"
export default component.exports